import React, { useState, useEffect, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import URLstateContext from "../../../../provider/CommonContext";
import renderHTML from "react-render-html";
import { Vortex } from "react-loader-spinner";
import animation from "../../../../images/jm-animation.gif";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import "./FinQKYCOther.css";

import KYCIndividual from "../../../../PDF/Partner Offline Empanelment/KYC-Individual.pdf";
import KYCNonIndividual from "../../../../PDF/Partner Offline Empanelment/KYC-Non-Individual.pdf";
import MandateForm from "../../../../PDF/Partner Offline Empanelment/Change-of-Bank-Mandate-Form.pdf";

function FinQKYCOther() {
  const [data, setData] = useState(false);
  const { BaseURL } = useContext(URLstateContext);
  const [loadingshow, setloadingshow] = useState(false);

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetFAQ", {
      faqcatid: "3",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
  }, [BaseURL]);
  

  return (
    <>
    <main>
      <Container>
        <Row>
          <Col sm={12}>
            <div className="kyc-para-container" style={{ padding: "10px" }}>
              <h3>Know Your Customer (KYC) Procedure</h3>

              <p>
                Investors are required to get their one-time Centralized Know
                Your Customer (CKYC) completed prior to making their
                investments. CKYC is managed by a Government authorized body
                named CERSAI which receives, stores, safeguards and retrieves
                all KYC records in digital form. CKYC enables investors to
                complete their KYC only once for opening accounts with various
                entities across the financial services sector viz. Mutual Funds,
                Banks, Insurance, DP, Stock broker, Depository Participant, etc.
                <br></br>
                <a
                  href={KYCIndividual}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="kyc-link"
                  aria-label="Download CKYC Form (PDF, opens in a new tab)"
                >
                  CKYC Form
                </a>{" "}
                can be submitted at any of the Investor Service Centre (ISC) of
                any mutual fund along with:
                <br></br>
                <ul>
                  <li>
                    Proof of identity (PoI): PAN/any other document (for
                    PAN-exempt investors) listed in the form
                  </li>
                  <li>
                    Proof of address (PoA): Any one document listed in the form
                  </li>
                  <li>
                    NRI/PIO/OCI - Copy of passport/PIO Card/OCI Card and
                    overseas Proof of Address
                  </li>
                  <li>
                    Non-Individuals (Companies, Trusts, etc.) can use{" "}
                    <a target="_blank" href={KYCNonIndividual}>
                      {" "}
                      KYC Form for Non Individual
                    </a>
                    .
                  </li>
                  <li>
                    Please refer to the Instruction/Checklist section on KYC
                    forms for a detailed list of the required documentation
                  </li>
                  <li>
                    Copies of all documents & In-Person Verification (IPV) shall
                    be attested by an authorized official of the mutual fund or
                    its Registrar & Transfer Agent (RTA-Cams, Karvy, etc.), your
                    Distributor or Bank Manager. All documents shall be
                    self-attested
                  </li>
                </ul>
                <p>
                  <b>How can you change your address details?</b>
                </p>
                <p>
                  - Submit aCKYC Form along with a self-attested Proof of
                  Address and PAN/any other proof of Identity at any of the
                  Investor Service Centre (ISC) of any mutual fund.
                  Non-Individuals can useKYC Form for Non Individual- Copies of
                  all documents & In-Person Verification (IPV) shall be attested
                  by an authorized official of the mutual fund or its Registrar
                  & Transfer Agent (RTA-Cams, Karvy, etc.), your Distributor or
                  Bank Manager. All documents shall be self-attested - Once the
                  address is updated in the centralised KRA records, it will
                  automatically get updated across all mutual funds where you
                  have folios
                </p>
                <p>
                  <b>
                    How can you change your contact details viz. email, mobile
                    number?
                  </b>
                </p>
                <p>
                  - Send an email to the{" "}
                  <a target="_blank" href="mailto:investor@jmfl.com">
                    investor@jmfl.com
                  </a>{" "}
                  from your email ID currently registered with the mutual fund,
                  or visit
                  <a
                    target="_blank"
                    href="https://mfs.kfintech.com/investor/Transact/ChangeFolioEmail"
                  >
                    {" "}
                    https://mfs.kfintech.com/investor/Transact/ChangeFolioEmail
                  </a>{" "}
                  or Speak to the Call centre of the mutual fund from your
                  mobile number registered with the mutual fund, or - Submit the
                  Email ID/Mobile registration at any of the Points of Service
                  (POS)/Investor Service Centre (ISC) of the mutual fund along
                  with self-attested copy of PAN/Any valid PoI (for PAN-exempt
                  investors)
                </p>
                <p>
                  <b>How can you change your bank details?</b>
                </p>
                <p>
                  Bank account details can be changed by submitting a{" "}
                  <a target="_blank" href={MandateForm}>
                    Change of Bank Mandate Form
                  </a>{" "}
                  at any of the ISC of any mutual fund. What is required along
                  with the form? Any one of the following either in original or
                  attested by the Bank: - Cancelled Cheque from the new bank
                  account - Latest Bank Statement - Latest copy of bank passbook
                  with name & a/c number printed on it - Bank Letter
                </p>
                <p>
                  <b>
                    What are the modes of submitting a complaint or a grievance?
                  </b>
                </p>
                <p>
                  - Send an email to the{" "}
                  <a target="_blank" href="mailto:investor@jmfl.com">
                    investor@jmfl.com
                  </a>{" "}
                  or Speak to the Call centre on toll free number 1800 1038 345
                  or fill the contact details in get in touch section of our
                  website or Submit/Post a written letter to any of the Investor
                  Service Centres (ISCs) of the Mutual fund - If you transacted
                  through BSE/NSE, approach either the stock broker or the
                  investor grievance cell of the respective stock exchange. - If
                  you transacted through Mutual Funds Utilities India (MFU),
                  contact the customer care of MFUI on 1800-266-1415 or +91 22
                  6134 4316
                </p>
                <p>
                  - If the complaint remains unresolved, you can also approach
                  SEBI by logging a complaint on SEBI’s complaints redressal
                  system{" "}
                  <a
                    target="_blank"
                    href="https://scores.gov.in/scores/Welcome.html"
                  >
                    https://scores.gov.in/scores/Welcome.html
                  </a>
                </p>
              </p>
            </div>
          </Col>
        </Row>
      </Container>

    </main>
    </>
  );
}

export default FinQKYCOther;
